import React from 'react';
import ManageCandidateMeetings from "../../components/meetings/ManageCandidateMeetings";
import Scrollbars from "react-custom-scrollbars";

const MeetingsTab = ({candidate, position}) => {

    return (
        <React.Fragment>

            <Scrollbars style={{width: `100%`, height: 400}}>

                <ManageCandidateMeetings
                    candidate={candidate}
                    position={position}/>

            </Scrollbars>

        </React.Fragment>
    );
};

export default MeetingsTab;

// add filter to chat photos